import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';

function utmMediumCell(visibleColumns: any) {
  if (!visibleColumns.includes('utmMedium')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('UTM-Medium', { ns: 'sales' })} />,
    dataIndex: ['utmMedium'],
    key: 'utmMedium',
    render: (utmMedium: any) => <CellText>{utmMedium}</CellText>,
    width: 150,
  };
}

export default utmMediumCell;
